import { graphql } from "gatsby"

import { styled, Box, Container, Text } from "@mode/components"
import Image from 'gatsby-plugin-sanity-image'
import Marquee from 'react-fast-marquee'
import { pbkdf2 } from "crypto"

const Row = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: '$sm',
  '&:last-of-type': {
    mb: 0
  }
})

const Logo = styled('div', {
  height: "100%",
  display: "flex",
  "@md": {
    maxWidth: 'calc(100% / 6)',
  }
})

const StyledImage = styled(Image, {
  maxHeight: '200px',
})

export const LogoMarquee = ({ 
    heading,
    headingSize,
    dark,
    rows,
    background,
    marginTop,
    paddingTop,
    paddingBottom
  }) => {
  return (
    <Box css={{ background: background ?? 'transparent', mt: marginTop ?? '$sm' }}>
      <Container css={{ 
        pt: paddingTop ?? '$sm',
        pb: paddingBottom ?? '$sm',
        '@md': { 
          pt: paddingTop ?? '$md',
          pb: paddingBottom ?? '$md', 
        } }} collapseOnMobile>
        {heading &&
          <Text
            textStyle={headingSize === null ? 'h2' : headingSize}
            css={{ 
              color: dark ? '$g1' : '$g5',
              textAlign: 'center', 
              pb: '$sm',
            }}
            as="h2"
          >
            {heading}
          </Text>
        }
        <Box css={{ display: 'none', '@lg': { display: 'block' } }}>
          {rows.map(row => {
            return (
              <Row key={row._key}>
                {row.logos && row.logos.map(logo => {
                  return (
                    <Logo key={logo._key}>
                      {logo && <StyledImage {...logo} role="presentation" alt={logo.alt || ''} />}
                    </Logo>
                  )
                })}
              </Row>
            )
          })}
        </Box>
        <Box css={{ display: 'block', '@lg': { display: 'none' } }}>
          <Row>
            <Marquee gradient={false} direction='left' speed={70}>
              {rows.map((row) => {
                return row.logos && row.logos.map(logo => {
                  return (
                    <Logo key={logo._key} css={{ mx: '$xxs' }}>
                      {logo && <StyledImage {...logo} alt={logo.alt || ''} />}
                    </Logo>
                  )
                })
              })}
            </Marquee>
          </Row>
        </Box>

      </Container>
    </Box>
  )
}

export const query = graphql`
  fragment LogoMarqueeContent on LogoMarquee {
    _key
    heading
    headingSize
    dark
    background
    rows {
      _key
      logos {
        _key
        ...ImageWithPreview
      }
    }
    marginTop
    paddingTop
    paddingBottom
  }
`